import React from "react";
import { SpinnerIcon } from "../Icons";
import styles from "../statics/styles/spinner-scss";
const Spinner = () => {
  return /* @__PURE__ */ React.createElement(SpinnerIcon, { className: styles.spinner });
};
var Spinner_default = Spinner;
export {
  Spinner_default as default
};
//# sourceMappingURL=Spinner.js.map
